import { makeUtilDatasource } from "@/main/factories/datasources/util-datasource-factory";
import { useEffect, useMemo, useState } from "react";
export var useLocationCities = function (stateId, asOption) {
    var _a = useState(undefined), isLoading = _a[0], setIsLoading = _a[1];
    var _b = useState([]), cities = _b[0], setCities = _b[1];
    useEffect(function () {
        var utilRepository = makeUtilDatasource();
        if (stateId <= 0 || isNaN(stateId) || !stateId) {
            setCities([]);
            return;
        }
        setIsLoading(true);
        utilRepository
            .getCities(stateId)
            .then(function (cts) {
            setCities(cts);
            setIsLoading(false);
        })
            .catch(function () {
            setIsLoading(false);
        });
    }, [stateId]);
    return useMemo(function () {
        if (asOption) {
            var options = cities.map(function (city) { return ({
                label: city.description,
                value: city.id.toString(),
            }); });
            return {
                isLoading: isLoading,
                cities: options,
            };
        }
        return {
            isLoading: isLoading,
            cities: cities,
        };
    }, [isLoading, cities]);
};
